import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import LazyLoading from './Components/LazyLoading/LazyLoading.jsx';
const Index = lazy(() => import( "./Components/Index/Index.jsx"));
const NavBar = lazy(() => import("./Components/NavBar/NavBar.jsx"));
const About = lazy(() => import("./Components/About/About"));

function App() {
  return (
    <div className="App">
      <React.Fragment>
        <Suspense fallback={<LazyLoading/>} >
          <BrowserRouter>
            <NavBar /> 
            <Route exact path={"/"} render={() => <Index />} />
            <Route exact path={"/About"} render={() => <About />} />
          </BrowserRouter>
        </Suspense>
      </React.Fragment>
    </div>
  );
}

export default App;
